"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _swiftInputMultitoggleStyle = require("./swift-input-multitoggle-style");
var _swiftLabel = _interopRequireDefault(require("./swift-label"));
var _swiftInputCheckbox = _interopRequireDefault(require("./swift-input-checkbox"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _icons = _interopRequireDefault(require("../icons"));
var _polished = require("polished");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SwiftInputMultiToggleItemStyled = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 8px;\n\tborder: 2px solid #f8f8f8;\n\tmargin-bottom: 2px;\n\tcursor: pointer;\n\ti {\n\t\tmargin-right: 8px;\n\t\tsvg {\n\t\t\twidth: 18px;\n\t\t\theight: 18px;\n\t\t\topacity: 0.25;\n\t\t}\n\t}\n\tspan {\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t\topacity: 0.5;\n\t}\n\n\t", "\n"])), function (props) {
  return props.active ? "\n\n\t\t\ti {\n\t\t\t\tsvg {\n\t\t\t\t\topacity:1;\n\t\t\t\t}\n\t\t\t}\n\t\t\tspan {\n\t\t\t\topacity:1;\n\t\t\t}\n\t\t\n\n\t\t".concat(props.value === null ? "\n\t\t\tbackground: ".concat(props.theme.color_primary, ";\n\t\t\tcolor: ").concat((0, _polished.readableColor)(props.theme.color_primary), ";\n\t\t\ti {\n\t\t\t\tsvg {\n\t\t\t\t\tfill: ").concat((0, _polished.readableColor)(props.theme.color_primary), ";\n\t\t\t\t}\n\t\t\t}\n\t\t\tborder-color:").concat(props.theme.color_primary, ";\n\t\t") : "\n\t\t\ti {\n\t\t\t\tsvg {\n\t\t\t\t\tfill: ".concat(props.theme.color_primary, ";\n\t\t\t\t}\n\t\t\t}\n\t\t\tborder-color:").concat(props.theme.color_primary, ";\n\t\t"), "\n\t") : "\n\t\t&:hover {\n\t\t\ti {\n\t\t\t\tsvg {\n\t\t\topacity: 0.75;\n\t\t\t\t\tfill: ".concat(props.theme.color_primary, ";\n\t\t\t\t}\n\t\t\t}\n\t\t\tspan {\n\t\t\t\topacity:1;\n\t\t\t}\n\t\t\tborder-color:#f4f4f4;\n\t\t}\n\t");
});
var SwiftInputMultiToggleItem = function SwiftInputMultiToggleItem(props) {
  var icon = props.icon,
    name = props.name,
    value = props.value,
    active = props.active,
    handleClick = props.handleClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(SwiftInputMultiToggleItemStyled, {
    active: active,
    value: value,
    onClick: function onClick(e) {
      e.stopPropagation();
      handleClick();
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.default, {
      i: icon || "check"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: name
    })]
  });
};
var SwiftInputMultiToggle = function SwiftInputMultiToggle(props) {
  var value = props.value,
    values = props.values,
    name = props.name,
    onChange = props.onChange,
    key = props.key,
    cols = props.cols,
    selectAllLabel = props.selectAllLabel,
    selectMax = props.selectMax;

  // console.log('SwiftInputMultiToggle ----')
  // console.log('SwiftInputMultiToggle - values', values)
  // console.log('SwiftInputMultiToggle - ', props, ' = ', value)

  var everyChecked = true;
  if (value == null) {
    everyChecked = false;
  } else if (value != null) {
    values.map(function (elem) {
      if (elem.value === null || !elem.value.split(",").every(function (v) {
        return value.split(",").includes(v);
      })) {
        everyChecked = false;
      }
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_swiftInputMultitoggleStyle.SwiftInputMultiToggleStyled, {
    count: props.values ? props.values.length : 0,
    cols: cols,
    valuesInline: props.valuesInline,
    children: [props.label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_swiftLabel.default, {
      children: props.label
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "swift_input_multitoggle_window",
      children: [props.selectAll && /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SwiftInputMultiToggleItem, {
          name: selectAllLabel,
          value: null,
          icon: "star",
          active: value == null || everyChecked ? true : false,
          handleClick: function handleClick() {
            if (value == null || everyChecked) {
              onChange("");
            } else {
              onChange(null);
            }
          }
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "swift_input_multitoggle_values",
        children: values.map(function (elem, i) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SwiftInputMultiToggleItem, _objectSpread(_objectSpread({}, elem), {}, {
              active: value == null || value && elem.value.split(",").every(function (v) {
                return value.split(",").includes(v);
              }) ? true : false,
              handleClick: function handleClick() {
                var valueSplit = value ? value.split(",") : [];
                var valueAll = [];
                values.forEach(function (v) {
                  valueAll = [].concat((0, _toConsumableArray2.default)(valueAll), (0, _toConsumableArray2.default)(v.value.split(",")));
                });
                if (value == null) valueSplit = valueAll;
                //console.log('vsplit - ', valueSplit)
                //console.log('valueAll - ', valueAll)

                var isActiveNow = value == null || value && elem.value.split(",").every(function (v) {
                  return value.split(",").includes(v);
                });
                if (!isActiveNow) {
                  if (!selectMax || value.split(",").length < selectMax) {
                    console.log("adding item, under selectMax", selectMax);
                    // add value to value
                    var valueNew = [].concat((0, _toConsumableArray2.default)(valueSplit), (0, _toConsumableArray2.default)(elem.value.split(","))).join(",");
                  } else {
                    console.log("adding item, selecting over max!", selectMax);
                    var valueNew = [].concat((0, _toConsumableArray2.default)(valueSplit.slice(1)), (0, _toConsumableArray2.default)(elem.value.split(","))).join(",");
                  }

                  // did this result in all being selected?
                  if (valueNew.split(",").length == valueAll.length) {
                    valueNew = null;
                  }
                } else {
                  // remove this value from value
                  var valueNew = (0, _toConsumableArray2.default)(valueSplit.filter(function (v) {
                    return !elem.value.split(",").includes(v);
                  })).join(",");
                  // if (valueNew == '') {
                  // 	valueNew = null;
                  // }
                  if (selectMax && valueNew.split(",").length > selectMax) {
                    // deselecting but still over limit, try only selecting this one!
                    valueNew = elem.value;
                  }
                }

                //console.log('vnew - ', valueNew)

                props.onChange(valueNew);
              }
            }))
          }, i);
        })
      })]
    }), props.error && props.helperText ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_swiftLabel.default, {
      error: true,
      children: props.helperText
    }) : null]
  });
};
SwiftInputMultiToggle.defaultProps = {
  selectMax: null,
  cols: 1,
  selectAll: true,
  selectAllLabel: "Select All",
  valuesInline: false
};
var _default = SwiftInputMultiToggle;
exports.default = _default;